<main>
    <section class="container d-flex flex-column">
     <div class="row">
      <div class="offset-xl-1 col-xl-2 col-lg-12 col-md-12 col-12">
       <div class="mt-4">
        <a href="/"><img src="../../../assets/images/logo/logo.png" alt="" class="logo-inverse" style="width: 10rem;"></a>
       <!-- theme switch -->

       </div>
      </div>
     </div>
     <div class="row align-items-center justify-content-center g-0  py-5">
      <!-- Docs -->
      <div class="offset-xl-1 col-xl-4 col-lg-6 col-md-12 col-12 text-center text-lg-start">
       <h1 class="display-1 mb-3">404</h1>

       <p class="mb-5 lead px-4 px-md-0">Oops! Sorry, Unauthorized Access </p>
       <a href="/login" class="btn btn-primary me-2">Back to Safety</a>
      </div>
      <!-- img -->
      
     </div>
    
    </section>
   </main>
